// Display helpers for the Customers page.
//
// `getInitials` produces a 1-2 character placeholder shown in the logo square
// when a customer has no uploaded image. Spec from the redesign plan
// ([[the-vault-customers-redesign-2026-05]]):
//
//   - First letter of the first word + first letter of the last word
//   - Single-word names fall back to the first two characters
//   - Tokens that contain no alphanumerics (e.g. "&", "+") are skipped so
//     "A & T TRADING" still resolves to first-word "A" and last-word "TRADING"
//   - Always uppercased

export function getInitials(name) {
  const cleaned = String(name || '').trim();
  if (!cleaned) return '';
  const tokens = cleaned.split(/\s+/).filter((t) => /[A-Za-z0-9]/.test(t));
  if (tokens.length === 0) return cleaned.slice(0, 2).toUpperCase();
  if (tokens.length === 1) {
    const word = tokens[0].replace(/[^A-Za-z0-9]/g, '');
    return (word.slice(0, 2) || word).toUpperCase();
  }
  const firstWord = tokens[0].replace(/[^A-Za-z0-9]/g, '');
  const lastWord = tokens[tokens.length - 1].replace(/[^A-Za-z0-9]/g, '');
  const first = firstWord ? firstWord[0] : '';
  const last = lastWord ? lastWord[0] : '';
  return (first + last).toUpperCase() || cleaned.slice(0, 2).toUpperCase();
}

// Append a cache-buster query param to a logo URL so a freshly-replaced blob
// is not served from a stale browser/CDN cache. Pass the timestamp from the
// upload response, or omit to use Date.now().
export function withCacheBuster(url, version) {
  if (!url) return url;
  const v = version != null ? version : Date.now();
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${v}`;
}
